type DataLayerEvent = Record<string, unknown>;

type VoucherRegistrationResponse = {
  gaTracking?: Record<string, unknown>;
};

declare global {
  interface Window {
    dataLayer?: DataLayerEvent[];
  }
}

/** Push a GTM-compatible event without requiring the analytics container to be loaded first. */
export function pushDataLayerEvent(event: DataLayerEvent): void {
  (window.dataLayer ??= []).push(event);
}

function trackingAmount(value: unknown): string {
  return Number(value ?? 0).toPrecision(2);
}

/**
 * Keep the legacy voucher-registration purchase payload intact while making
 * the transport reusable for other client-side conversions.
 */
export function pushVoucherRegistrationAnalytics(response: VoucherRegistrationResponse): void {
  const tracking = response.gaTracking;
  if (!tracking) {
    return;
  }

  const amountNet = trackingAmount(tracking["ga-tracking-amount-net"]);
  const amountTax = trackingAmount(tracking["ga-tracking-amount-tax"]);
  const voucher = tracking["ga-tracking-voucher"];

  pushDataLayerEvent({
    ecommerce: {
      purchase: {
        actionField: {
          id: tracking["ga-tracking-transaction-id"],
          affiliation: "YogaMeHome Webseite",
          revenue: amountNet,
          tax: amountTax,
          shipping: "0.00",
          coupon: voucher,
        },
        products: [
          {
            name: tracking["ga-tracking-name"],
            id: tracking["ga-tracking-sku"],
            price: amountNet,
            brand: "YogaMeHome",
            category: tracking["ga-tracking-category"],
            quantity: 1,
            coupon: voucher,
          },
        ],
      },
    },
  });
  pushDataLayerEvent({ event: "plugin_lead" });
}
